var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoWebsite = function SvgLogoWebsite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10m7.938-9h-3.97a40 40 0 0 1-.805 6.35A8.01 8.01 0 0 0 17.938 11m-6.95 6.94.037-.16q.794-3.519.941-6.78H8.034q.148 3.262.942 6.78l.037.16a8 8 0 0 0 1.976 0m-4.151-.59A8.01 8.01 0 0 1 2.062 11h3.97a40 40 0 0 0 .805 6.35M17.938 9a8.01 8.01 0 0 0-4.725-6.329q.73 2.982.783 6.329zm-6.961-6.941a8 8 0 0 0-1.954 0l-.062.217Q8.066 5.392 8.004 9h3.992q-.061-3.608-.957-6.724zm-4.19.612Q6.057 5.653 6.004 9H2.062a8.01 8.01 0 0 1 4.725-6.329",
    clipRule: "evenodd"
  })));
};
export default SvgLogoWebsite;